var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-relative is-full-height"},[_c('tabs-page',{attrs:{"title":"Offer Management","tabs":_vm.tabs,"keep-alive":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }